import { render, staticRenderFns } from "./OrganizationOwnerList.vue?vue&type=template&id=8473f972&"
import script from "./OrganizationOwnerList.vue?vue&type=script&lang=js&"
export * from "./OrganizationOwnerList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports